import React from 'react';

import styled from 'styled-components';

import useHeaderLines from '@hooks/Layout/UseHeaderLines';

import CompanyLogo from './CompanyLogo';

const StyledPrintableHeader = styled.div`
    /* media query for print */
    @media print {
        position: fixed;
        top: 0;
        width: 100%;
    }

    display: flex;
    justify-content: ${(props) => (props.$centeredLayout ? 'center' : 'space-between')};
    align-items: center;
    margin-bottom: 3rem;
    padding: 0 1rem 0 0.5rem;

    .printable-header-right {
        text-align: right;
        p {
            margin: 0;
            font-size: ${(props) => props.theme.FontSizeSm};
        }
    }
`;

const PrintableHeader = ({ onlyLogo = false }) => {
    const headerLines = useHeaderLines();
    const centeredLayout = onlyLogo || headerLines.length === 0;

    return (
        <StyledPrintableHeader $centeredLayout={centeredLayout}>
            {centeredLayout ? (
                <CompanyLogo />
            ) : (
                <>
                    <div className="printable-header-left">
                        <CompanyLogo />
                    </div>
                    <div className="printable-header-right">
                        {headerLines.map((line, index) => (
                            <p key={index}>{line}</p>
                        ))}
                    </div>
                </>
            )}
        </StyledPrintableHeader>
    );
};

export default PrintableHeader;
